import React from 'react';
import { TextField } from '@mui/material';
import { BaseInputProps } from './types';

export const LongTextInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  textInputPlaceholder,
}) => (
  <TextField
    fullWidth
    multiline
    rows={5}
    placeholder={textInputPlaceholder}
    value={answers[currentQuestion.id]?.longText || ''}
    onChange={(e) =>
      dispatch({
        type: 'SET_LONG_TEXT',
        questionId: currentQuestion.id,
        payload: e.target.value,
      })
    }
    slotProps={{ htmlInput: { 'data-testid': 'form-preview-long-text-input' } }}
  />
);
